import { render, staticRenderFns } from "./signup-button-modal.vue?vue&type=template&id=4b990074&scoped=true"
import script from "./signup-button-modal.vue?vue&type=script&lang=js"
export * from "./signup-button-modal.vue?vue&type=script&lang=js"
import style0 from "./signup-button-modal.vue?vue&type=style&index=0&id=4b990074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b990074",
  null
  
)

export default component.exports